export function customerNew(state) {
  return state.customerNew;
}
